import createPriceBandPromises from './createPriceBandPromises';
export default createPriceBandPromises;
